import src from "IMAGE";
export default { src, width: 1439, height: 303, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAAI0lEQVR42k3KQQoAAAgCQbP//zkpi4S5yAKzEEoa/d02+DooAxgAFyl8cKYAAAAASUVORK5CYII="};
